import React from "react";

class Popup_Manager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // 이름
      // 전화번호
      // 생년월일
      // 부대(소속)
      Itemkey: "none",
      item: {},
    };
  }

  update = () => {
    this.props.update({ ...this.props.item, ...this.state.item });
    this.closepopup();
  };

  closepopup() {
    document.getElementById("modal").style.display = "none";
  }

  handleSelectChange = (e) => {
    this.myinput.value = "";
    this.setState({
      Itemkey: e.target.value,
    });
  };

  handleChange = (e) => {
    let item = this.state.item;
    item[this.state.Itemkey] = e.target.value;
    this.setState({
      item: item,
    });
  };

  render() {
    return (
      <>
        <div
          className="manager_tool_popup"
          id="modal"
          style={{ color: "black" }}
        >
          <div className="popup_content">
            <p>
              변경할 값을 넣어주세요 <br />{" "}
              <b>( 빈공간이면 값이 변경되지 않습니다. )</b>
            </p>
            <select onChange={this.handleSelectChange} name="category">
              <option defaultValue value="none">
                변경할 값을 선택해주세요
              </option>
              {this.props.item
                ? Object.entries(this.props.element).map((x) => {
                    return (
                      <>
                        <option value={x[0]}>{x[1]}</option>
                      </>
                    );
                  })
                : null}
            </select>
            <input
              ref={(ref) => {
                this.myinput = ref;
              }}
              type="text"
              onChange={this.handleChange}
              name={this.state.Itemkey}
              style={{ outline: "black solid 1px" }}
              placeholder={
                this.state.Itemkey !== "none" && this.props.item
                  ? this.props.item[this.state.Itemkey]
                  : null
              }
            />
          </div>
          <div className="popup_btn">
            <button onClick={this.update}>확인</button>
            <button onClick={this.closepopup}>취소</button>
          </div>
        </div>
      </>
    );
  }
}

export default Popup_Manager;
